// extracted by mini-css-extract-plugin
export var animation = "CentralizedPlatform-module--animation--hCjEj";
export var tabletSize = "CentralizedPlatform-module--tablet-size--B80oy";